import useAuth from '../../../context/Auth';
import { useLandaApiAxios } from '../../api/axios/landa_api';
import { useEffect, useState } from 'react';
import { singletonHook } from 'react-singleton-hook';

interface LeaseAttributes {
  lease_id: string;
  start_date: string;
  pay_first_payments?: boolean | null;
}

interface SignLeaseBody {
  data: {
    attributes: LeaseAttributes;
  };
}

const init: {
  data?: any;
  request: (body: SignLeaseBody) => Promise<boolean>;
  signing: boolean;
  success: boolean | null;
} = {
  data: undefined,
  request: async () => false,
  signing: false,
  success: null,
};

const useFetchSignLease = () => {
  const { isLoggedIn } = useAuth();
  const [success, setSuccess] = useState<boolean | null>(null);
  const [requestSign, { loading: signing }] = useLandaApiAxios({
    url: '/sign_rent_lease',
    method: 'POST',
  });

  const request = async (body: SignLeaseBody) => {
    try {
      const response = await requestSign({ data: body });
      if (response.status === 200 || response.status === 201) {
        setSuccess(true);
        return true;
      }
      setSuccess(false);
      return false;
    } catch (error) {
      setSuccess(false);
      return false;
    }
  };

  useEffect(() => {
    if (!isLoggedIn) return;
  }, [isLoggedIn]);

  return {
    request,
    success,
    signing,
  };
};

export default singletonHook(init, useFetchSignLease);
